/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';

// ** MUI Components
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';

import illustration from '../../assets/location-concept-light.svg';
import api from '../../services/api';
import './styles.css';

export default function BeaconNew() {
  const navigate = useNavigate();

  const [beacon, setBeacon] = useState({
    name: '',
    brand: '',
    type: 'iBeacon',
    deviceId: '',
    major: 0,
    minor: 0,
    namespace: '',
    instanceId: '',
    rssi: -55,
  });

  const handleInputChangeData = (e) => {
    const { name, value } = e.target;
    setBeacon(({
      ...beacon,
      [name]: value,
    }));
  };

  // Regex de UUID v4 (formato aceito pelo backend). Aceita maiúsculas e minúsculas.
  const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

  function validateBeacon(b) {
    if (!b.name || b.name.trim() === '') {
      return 'O nome do beacon é obrigatório.';
    }
    if (!b.brand || b.brand === '') {
      return 'A marca do beacon não pode ser vazia.';
    }
    if (!b.deviceId || !UUID_REGEX.test(b.deviceId.trim())) {
      return 'O UUID do beacon é inválido. Formato esperado: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx';
    }
    const majorNum = Number(b.major);
    const minorNum = Number(b.minor);
    if (!Number.isInteger(majorNum) || majorNum < 0 || majorNum > 65535) {
      return 'Major deve ser um número inteiro entre 0 e 65535.';
    }
    if (!Number.isInteger(minorNum) || minorNum < 0 || minorNum > 65535) {
      return 'Minor deve ser um número inteiro entre 0 e 65535.';
    }
    return null;
  }

  async function handleRegister(e) {
    e.preventDefault();

    const validationError = validateBeacon(beacon);
    if (validationError) {
      alert(validationError);
      return;
    }

    const data = {
      name: beacon.name.trim(),
      brand: beacon.brand,
      type: beacon.type,
      deviceId: beacon.deviceId.trim().toLowerCase(),
      major: Number(beacon.major),
      minor: Number(beacon.minor),
      namespace: beacon.namespace || undefined,
      instanceId: beacon.instanceId || undefined,
      rssi: Number(beacon.rssi),
    };

    try {
      await api.post('/beacons', data);
      alert('Beacon criado com sucesso.');
      navigate('/beacons');
    } catch (err) {
      console.error(err);
      alert(err?.response?.data?.message || 'Erro ao cadastrar o beacon.');
    }
  }

  const handleGoBack = (e) => {
    e.preventDefault();
    navigate(-1);
  };

  return (
    <div className="new-beacon-container">
      <main className="content">
        <section>
          <img src={illustration} alt="Maps Indoor" />
        </section>
        <form onSubmit={handleRegister}>
          <h1>Novo Beacon</h1>
          <p>Preencha os dados referente ao beacon.</p>
          <FormControl
            fullWidth
            sx={{
              my: 1,
            }}
          >
            <TextField
              label="Nome"
              type="text"
              name="name"
              value={beacon.name}
              placeholder="Informe o nome do Beacon"
              onChange={(e) => handleInputChangeData(e)}
              required
            />
          </FormControl>
          <FormControl
            fullWidth
            sx={{
              my: 1,
            }}
          >
            <InputLabel id="brand-label">Marca</InputLabel>
            <Select
              id="brand"
              labelId="brand-label"
              label="Marca"
              name="brand"
              value={beacon.brand}
              onChange={(e) => handleInputChangeData(e)}
            >
              <MenuItem value="estimote">Estimote</MenuItem>
              <MenuItem value="kontakt">Kontakt</MenuItem>
              <MenuItem value="other">Outro</MenuItem>
            </Select>
          </FormControl>
          <FormControl
            fullWidth
            sx={{
              my: 1,
            }}
          >
            <TextField
              label="UUID"
              type="text"
              name="deviceId"
              value={beacon.deviceId}
              placeholder="Informe o ID do Beacon"
              helperText={(
                <span style={{ fontSize: '12px' }}>
                  Ex.: 5a921f29-de3c-e54c-60f7-dde6dd8d0fe8
                </span>
              )}
              onChange={(e) => handleInputChangeData(e)}
              required
            />
          </FormControl>
          <FormControl
            fullWidth
            sx={{
              my: 1,
            }}
          >
            <TextField
              label="MAC Address (opcional)"
              type="text"
              name="namespace"
              value={beacon.namespace}
              placeholder="Ex.: 00:FA:B6:0D:4B:08"
              helperText={(
                <span style={{ fontSize: '12px' }}>
                  Fallback quando iBeacon não é reconhecido. Recomendado p/ Kontakt.
                </span>
              )}
              onChange={(e) => handleInputChangeData(e)}
            />
          </FormControl>
          <FormControl
            fullWidth
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: 1,
              my: 1,
            }}
          >
            <TextField
              label="Major"
              type="number"
              name="major"
              value={beacon.major}
              placeholder="Major"
              helperText={(
                <span style={{ fontSize: '12px' }}>
                  Ex.: 2000
                </span>
              )}
              onChange={(e) => handleInputChangeData(e)}
              inputProps={{
                min: 0,
              }}
            />
            <TextField
              label="Minor"
              type="number"
              name="minor"
              placeholder="Minor"
              helperText={(
                <span style={{ fontSize: '12px' }}>
                  Ex.: 2000
                </span>
              )}
              value={beacon.minor}
              onChange={(e) => handleInputChangeData(e)}
              inputProps={{
                min: 0,
              }}
            />
          </FormControl>
          <Button
            sx={{
              mt: 1,
              width: '100%',
              height: 60,
            }}
            type="submit"
            size="large"
            variant="contained"
          >
            Cadastrar
          </Button>
          <div className="back-button">
            <Link className="back-link" to="#" onClick={handleGoBack}>
              <FiArrowLeft size={20} color="#414141" />
              Voltar para home
            </Link>
          </div>
        </form>
      </main>
    </div>
  );
}
